﻿window.session = function () {

    var myTimeoutTimerId;
    var sessionMinutes = 60;
    var numberOfSecondsLeft = 0;
    var initNumberOfSeconds = 0;

    // Update Counter method.
    function UpdateCountDown() {

        if (numberOfSecondsLeft > 0) {
            numberOfSecondsLeft--;
            myTimeoutTimerId = window.setTimeout(UpdateCountDown, 1000);
        }
        else {
            window.location = appsettings.getUrl("Account/Login?timeout=true");
            numberOfSecondsLeft = initNumberOfSeconds;
            myTimeoutTimerId = window.setTimeout(UpdateCountDown, 1000);
        }
    }

    return {
        // Init called in the shared _Layoout.cshtml (design and live)
        initialize: function (HTMLelement, sessionDuration) {

            if (sessionDuration > 0) {
                sessionMinutes = sessionDuration;
            }

            numberOfSecondsLeft = (sessionMinutes * 60);

            // Set init number (by initialize)
            initNumberOfSeconds = (sessionMinutes * 60);

            // onclick page reset counter
            HTMLelement.on("click", function (event) {
                numberOfSecondsLeft = initNumberOfSeconds;
            });

            UpdateCountDown();
        },

        // Get number of seconds left in the session.
        GetNumberSecondsLeft: function () {
            return numberOfSecondsLeft;
        },

        // Reset number of seconds by the saved var: initNumberOfSeconds
        ResetCounter: function () {
            if (myTimeoutTimerId != null) {
                numberOfSecondsLeft = initNumberOfSeconds;
            }
        }
    }
}();